import { FormField, RecordForm } from "@/components/forms/base-record-form";
import { useRecordForm } from "@/hooks/use-record-form";
import { Opportunity } from "@/types";

interface OpportunityFormProps {
  onCancel: () => void;
  path: string;
  onSuccess?: (opportunity: Opportunity) => void;
  initialData?: { name: string; looking_for?: string; brief_submission_uid?: string };
}

export function OpportunityForm({
  onCancel,
  path,
  onSuccess,
  initialData,
}: OpportunityFormProps) {
  const { data, setField, errors, isSubmitting, submit } = useRecordForm({
    path,
    param: "opportunity",
    initial: {
      name: initialData?.name || "",
      // A name is all a new opportunity needs (INCO-525). The side is set on
      // the record later, if at all; one the inbox already knows rides along
      // without being asked for.
      looking_for: initialData?.looking_for || "",
      // Carried through so an opportunity created from an inbound offer stays
      // linked to the submission it came from.
      brief_submission_uid: initialData?.brief_submission_uid || "",
    },
    onSuccess: (record) => onSuccess?.(record as unknown as Opportunity),
  });

  return (
    <RecordForm
      onSubmit={submit}
      onCancel={onCancel}
      isSubmitting={isSubmitting}
      submitLabel="Create opportunity"
    >
      <FormField
        label="Name"
        name="name"
        autoFocus
        value={data.name}
        onChange={(value) => setField("name", value)}
        errors={errors}
      />

    </RecordForm>
  );
}
